import { create } from 'zustand';

interface TickerData {
  symbol: string;
  price: number;
}

interface MultiAggState {
  tickers: Record<string, TickerData>;
  connect: (symbols: string[]) => void;
}

export const useMultiAggStore = create<MultiAggState>((set) => {
  let socket: WebSocket | null = null;
  let currentSymbols: string[] = [];
  const debounceTimers: Record<string, NodeJS.Timeout> = {};
  const pendingUpdates: Record<string, TickerData> = {};

  const connect = (symbols: string[]) => {
    const cleanSymbols = [...new Set(symbols)].sort();
    const cleanCurrent = [...currentSymbols].sort();
    if (JSON.stringify(cleanSymbols) === JSON.stringify(cleanCurrent)) return;

    currentSymbols = cleanSymbols;
    if (socket) socket.close();

    // 기존 타이머 정리
    Object.values(debounceTimers).forEach(timer => clearTimeout(timer));
    Object.keys(debounceTimers).forEach(key => delete debounceTimers[key]);
    Object.keys(pendingUpdates).forEach(key => delete pendingUpdates[key]);

    const streams = cleanSymbols.map((s) => `${s.toLowerCase()}@aggTrade`);
    const url = `wss://fstream.binance.com/stream?streams=${streams.join('/')}`;
    socket = new WebSocket(url);

    socket.onmessage = (event) => {
      const { data } = JSON.parse(event.data);
      const symbol = data?.s?.toLowerCase();
      const price = parseFloat(data?.p);

      if (!symbol || isNaN(price)) return;

      // 최신 데이터를 임시 저장
      pendingUpdates[symbol] = {
        symbol,
        price,
      };

      // 기존 타이머가 있으면 취소
      if (debounceTimers[symbol]) {
        clearTimeout(debounceTimers[symbol]);
      }

      // 0.1초 후 상태 업데이트
      debounceTimers[symbol] = setTimeout(() => {
        if (pendingUpdates[symbol]) {
          set((state) => ({
            tickers: {
              ...state.tickers,
              [symbol]: pendingUpdates[symbol],
            },
          }));
          delete pendingUpdates[symbol];
        }
      }, 100);
    };

    socket.onerror = (e) => {
      console.error('Ticker WebSocket Error:', e);
    };
  };

  return {
    tickers: {},
    connect,
  };
});
